export const applicant = {
  firstName: 'cfirstname',
  lastName: 'clastname',
  phone: 'cphone1',
  email: 'cemail',
  optIn: 'cphone1smsOptIn',
  address: 'caddress1',
  city: 'ccity',
  state: 'cstate',
  zip: 'czip',
  thirdPartyLeadExternalId: 'thirdPartyLeadExternalId',
  thirdPartyLeadExternalSku: 'thirdPartyLeadExternalSku',
  mailingAddress: 'caddress1Mail',
  mailingCity: 'ccityMail',
  mailingState: 'cstateMail',
  mailingZip: 'czipMail',

  guarantorAddress: 'cguarantorAddress1',
  guarantorCity: 'cguarantorCity',
  guarantorState: 'cguarantorState',
  guarantorZip: 'cguarantorZip',
  guarantorPhone: 'cguarantorPhone',

  businessName: 'cbusinessName',
  businessTitle: 'cbusinessTitle',
  businessPhone: 'cphone1',

  campaignId: 'campaignId',

  source: 'source',
};

export const applicantEligibility = {
  dateOfBirth: 'cdob',
  social: 'cssn',
  annualIncome: 'cgrossannualincome',
  applicantSignature: 'applicantSignature',
  coapplicantSignature: 'coapplicantSignature',
  cowner: 'cowner',
  cresident: 'cresident',
};

export const coApplicant = {
  firstName: 'csecondaryfirstname',
  lastName: 'csecondarylastname',
  phone: 'csecondaryphone',
  email: 'csecondaryemail',
  optIn: 'csecondaryPhoneSmsOptIn',
};

export const coApplicantEligibility = {
  dateOfBirth: 'csecondarydob',
  social: 'csecondaryssn',
  annualIncome: 'csecondarygrossannualincome',
  csecondaryowner: 'csecondaryowner',
  csecondaryresident: 'csecondaryresident',
};
